<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2><a href="#/account">{{$t('laboratories.title_parent')}}</a> <img class="p-pl-2 p-pr-2" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/> {{$t('laboratories.title')}}</h2>
        <div class="irinox-form">
          <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="labs">{{$t('laboratories.laboratory')}}</label>
                  <Dropdown id="labs" v-model="selectedLab" :options="labs" optionLabel="name" optionValue="id" 
                    :placeholder="$t('laboratories.laboratory_ph')" @change="changeLab" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <div v-if="lab.id!=null">
                  <label for="name">{{$t('laboratories.name')}}</label>
                  <InputText id="name" type="text" v-model="lab.name" 
                    :placeholder="$t('laboratories.name_ph')"
                    :class="{'p-invalid':v$.lab.name.$invalid && submitted}"/>
                </div>
              </div>
          </div>
          <div v-if="lab.id!=null" class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="dealer">{{$t('laboratories.dealer')}}</label>
                  <InputText id="dealer" type="text" v-model="lab.referenceDealer" :placeholder="$t('laboratories.dealer_ph')" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="assistance_center">{{$t('laboratories.assistance_center')}}</label>
                  <InputText id="assistance_center" type="text" v-model="lab.assistanceCenter" :placeholder="$t('laboratories.assistance_center_ph')" />
              </div>
          </div>
          <div v-if="lab.id!=null" class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="country">{{$t('laboratories.country')}}</label>
                  <Dropdown id="country" v-model="lab.country" :options="countries" optionLabel="name" optionValue="code" 
                    :placeholder="$t('laboratories.country_ph')" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="city">{{$t('laboratories.city')}}</label>
                  <InputText id="city" type="text" v-model="lab.city" :placeholder="$t('laboratories.city_ph')" />
              </div>
          </div>
          <div v-if="lab.id!=null" class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="address">{{$t('laboratories.address')}}</label>
                  <InputText id="address" type="text" v-model="lab.address" :placeholder="$t('laboratories.address_ph')" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                  <label for="district">{{$t('laboratories.district')}}</label>
                  <InputText id="district" type="text" v-model="lab.district" :placeholder="$t('laboratories.district_ph')" />
              </div>
          </div>
          <div v-if="lab.id!=null" class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                  <label for="postalCode">{{$t('laboratories.postalCode')}}</label>
                  <InputText id="postalCode" type="text" v-model="lab.postalCode" :placeholder="$t('laboratories.postalCode_ph')" />
              </div>
              <div class="p-field p-col-12 p-md-6">
              </div>
          </div>
        </div>
		</div>
	</div>
  <div class="footer-toolbar">
      <Button v-if="lab.id!=null" :label="$t('laboratories.delete_button')" class="p-button-secondary" @click="deleteDialog = true" />
      <Button v-if="lab.id!=null" :label="$t('laboratories.save_button')" autofocus @click="save(!v$.$invalid)" />
  </div>

  <IrinoxDialogDark :visible="successDialog" mode="success" :message="$t('laboratories.success_dialog')"
    :life="3000" @update:visible="successDialog = $event" />

  <IrinoxDialogDark :visible="errorDialog" mode="error" :message="$t('laboratories.error_dialog')"
    :life="3000" @update:visible="errorDialog = $event" />

  <IrinoxDialogDark :visible="conflictDialog" mode="error" :message="$t('laboratories.conflict_dialog')"
    :life="5000" @update:visible="conflictDialog = $event" />

  <IrinoxDialogDark :visible="blockingErrorDialog" mode="error" :message="$t('laboratories.error_dialog')"
    :life="0" @update:visible="blockingErrorDialog = $event" />

  <IrinoxDialogLight :visible="addDialog" mode="lab"
    @update:visible="addDialog = $event" 
    @click:button="addLab" />

  <IrinoxDialogDark :visible="deleteDialog" mode="confirm" 
    :leftB="$t('laboratories.delete_dialog_cancel_button')" @click:left-button="deleteDialog = false" 
    :rightB="$t('laboratories.delete_dialog_ok_button')" @click:right-button="deleteLab" 
    :message="$t('laboratories.delete_dialog')"
    icon="assets/irinox/icons/delete_big.svg" />

  
</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import CountryService from '../../service/CountryService';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import IrinoxDialogLight from '../IrinoxDialogLight.vue';

export default {
    components: {
        IrinoxDialogDark,
        IrinoxDialogLight
    },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
          labs: [],
          selectedLab: null,
          lab: {},
          countries: [],
          submitted: false,
          successDialog: false,
          errorDialog: false,
          blockingErrorDialog: false,
          addDialog: false,
          deleteDialog: false,
          conflictDialog: false
        };
    },
    watch: {
      selectedLab: 'changeLab'
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
        }),
    },
    validations() {
        return {
            lab: {
              name: {
                  required
              },
            }
        }
    },
    created() {
      this.countryService = new CountryService();
      this.applianceService = new ApplianceService();
    },
    mounted() {
        this.countryService.getCountries().then((countries) => {
            this.countries = countries;
        });
        this.getLabs();
    },
    methods: {
      getLabs() {
        this.applianceService.getLabs(this.personaltoken)
          .then(labs => {
            this.populateLabs(labs);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.blockingErrorDialog = true;
          });
      },
      populateLabs(labs) {
        this.labs = labs;
        this.labs.sort((a,b) => this.$functions.compareStrings(a, b, "name"));
        this.labs.push({ id: -1, name: this.$t('laboratories.laboratory_add') });
      },
      changeLab() {
        if(this.selectedLab!=null) {
          if(this.selectedLab==-1) {
            this.selectedLab = 0;
            this.lab = {};
            this.addDialog = true;
          } else {
            for (let i = 0; i < this.labs.length; i++) {
              if(this.labs[i].id == this.selectedLab) {
                this.lab = this.labs[i];
              }
            }
          }
        } else {
          this.lab = {};
        }
      },
      save(isFormValid) {
        this.submitted = true;

        if (!isFormValid) {
          return;
        }

        let updateData = {};
        updateData.name = this.lab.name;
        updateData.country = this.lab.country;
        updateData.city = this.lab.city;
        updateData.address = this.lab.address;
        updateData.district = this.lab.district;
        updateData.postalCode = this.lab.postalCode;
        updateData.referenceDealer = this.lab.referenceDealer;
        updateData.assistanceCenter = this.lab.assistanceCenter;

        this.applianceService.putLabs(this.personaltoken, this.lab.id, updateData)
          .then(labs => {
            this.successDialog = true;
            this.populateLabs(labs);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });
      },
      addLab(labName) {
        let updateData = {};
        updateData.name = labName;

        this.applianceService.postLabs(this.personaltoken, updateData)
          .then(labs => {
            this.addDialog = false;
            this.successDialog = true;
            this.populateLabs(labs);
          })
          .catch(error => {
            this.addDialog = false;
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });

      },
      deleteLab() {
        this.applianceService.deleteLabs(this.personaltoken, this.lab.id)
          .then(data => {
            this.deleteDialog = false;
            if(data.code == "200") {
              this.selectedLab = null;
              this.successDialog = true;
              this.getLabs();
            } else if(data.code == "570") {
              this.conflictDialog = true;
            } else {
              this.errorDialog = true;
            }
          })
          .catch(error => {
            this.deleteDialog = false;
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });
      }
    }
}
</script>

<style>

</style>